var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('v-text-field',{staticStyle:{"max-width":"300px"},attrs:{"hide-details":"","label":_vm.$t('search'),"placeholder":_vm.$t('search'),"filled":"","rounded":"","light":"","dense":"","single-line":"","value":_vm.search,"append-icon":"mdi-magnify"},on:{"input":function($event){return _vm.onSearch($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }